export const CalloutTypes = {
  tip: {
    accentColor: '#7fd1de',
    backgroundColor: '#e5f5f8'
  },
  note: {
    accentColor: '#7fded2',
    backgroundColor: '#e5f8f6'
  },
  caution: {
    accentColor: '#f8a9ad',
    backgroundColor: '#fdedee'
  },
  warning: {
    accentColor: '#e68250',
    backgroundColor: '#ffebe6'
  }
};